<template>
  <div>
    <main class="main reception">
      <div class="section call-guidance">
        <div class="call-guidance--rectangle">
          <h4>
              본인인증에 실패했습니다.
            <br />다시 시도하기 버튼을 눌러주세요
          </h4>
        </div>
      </div>
      <div class="section bottom">
        <button
          v-ripple
          class="button next-button"
          type="button"
          @click="$router.push({name: 'kyc/form'})"
        >다시 시도하기</button>
      </div>
    </main>
  </div>
</template>
<script>
export default {
  created() {
    this.$store.commit('ui/headerTitle', '본인인증 확인하기')
  }
}
</script>
<style scoped>
  .call-guidance--rectangle {
    text-align: center;
  }
</style>
